import {
  GET_SCOPE_YEARS_REQUEST,
  GET_SCOPE_YEARS_SUCCESS,
  GET_SCOPE_YEARS_FAIL,

  GET_EXCHANGE_SYSTEMS_REQUEST,
  GET_EXCHANGE_SYSTEMS_SUCCESS,
  GET_EXCHANGE_SYSTEMS_FAIL,

  GET_REGION_REQUEST,
  GET_REGION_SUCCESS,
  GET_REGION_FAIL,

  GET_SITES_REQUEST,
  GET_SITES_SUCCESS,
  GET_SITES_FAIL,

  GET_ACTIVITIES_REQUEST,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAIL,

  GET_FIELD_TASKS_REQUEST,
  GET_FIELD_TASKS_SUCCESS,
  GET_FIELD_TASKS_FAIL,

  GET_FORECASTS_REQUEST,
  GET_FORECASTS_SUCCESS,
  GET_FORECASTS_FAIL,

  GET_BTS_REQUEST,
  GET_BTS_SUCCESS,
  GET_BTS_FAIL,

  GET_CONTRACTS_REQUEST,
  GET_CONTRACTS_SUCCESS,
  GET_CONTRACTS_FAIL,

  GET_PERMITS_REQUEST,
  GET_PERMITS_SUCCESS,
  GET_PERMITS_FAIL,

  GET_INVOICES_REQUEST,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_FAIL,

  LOAD_DATA_REQUEST,
  LOAD_DATA_SUCCESS,
  LOAD_DATA_FAIL,
} from "../actions/dashboard";

const initialState = {
  headerMenuList: [],
  scopeYears: [],
  systems: [],
  regions: [],
  loading: false,
  systemCount: [],
  sites: [],
  activities: [],
  fieldTasks: [],
  forecast: [],
  bts: [],
  contracts: [],
  permits: [],
  invoices: [],
  milestoneSummary: [],
  milestoneProgress: [],
  map: {},
  loadingData: true,
  loadingMilestone: true,
  loadingMap: true,
};

const reducersHelper = (state, action) => {
  return {
    ...state,
    [action.name]: action.payload,
  };
}

export default function dashboard(state = initialState, action) {
  switch (action.type) {

    case GET_SCOPE_YEARS_REQUEST:
    case GET_REGION_REQUEST:
    case GET_EXCHANGE_SYSTEMS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    
    case LOAD_DATA_REQUEST:
        return {
          ...state,
          loadingData: true,
        };

    case GET_SCOPE_YEARS_SUCCESS:
      return {
        ...state,
        scopeYears: action.payload,
        loading: false,
      };
    
    case GET_EXCHANGE_SYSTEMS_SUCCESS:
      return {
        ...state,
        systems: action.payload,
        loading: false,
      };

    case GET_SCOPE_YEARS_FAIL:
    case GET_REGION_FAIL:
    case GET_EXCHANGE_SYSTEMS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_REGION_SUCCESS:
      return {
        ...state,
        regions: action.payload,
        loading: false,
      };
    
    case LOAD_DATA_SUCCESS:
    case LOAD_DATA_FAIL:
      return {
        ...state,
        loadingData: false,
      };
    
    case GET_SITES_SUCCESS:
    case GET_ACTIVITIES_SUCCESS:
    case GET_FIELD_TASKS_SUCCESS:
    case GET_FORECASTS_SUCCESS:
    case GET_BTS_SUCCESS:
    case GET_CONTRACTS_SUCCESS:
    case GET_PERMITS_SUCCESS:
    case GET_INVOICES_SUCCESS:
      return reducersHelper(state, action)

    default:
      return state;
  }
}
